import { Observable } from 'rxjs'
import http from '../adapters/http'
import { validTokenCookie } from '~/utils/general'

export default {
  // currently on analytic & phoneNumbers, doesnt need to add organization_id
  analytic(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    return new Observable(
      (observer) => new http.GET(observer, baseUrl, params, headers)
    )
  },
  phoneNumbers(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    return new Observable(
      (observer) => new http.GET(observer, baseUrl, params, headers)
    )
  },
  contactBlock(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    return new Observable(
      (observer) => new http.POST(observer, baseUrl, params, headers)
    )
  },
  unblockContact(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    return new Observable(
      (observer) => new http.DELETE(observer, baseUrl, params, headers)
    )
  },
  getService(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    baseUrl = window.$nuxt.$auth.user
      ? baseUrl.replace(
          'v1/',
          'v1/' + window.$nuxt.$auth.user.organization_id + '/'
        )
      : baseUrl
    return new Observable(
      (observer) => new http.GET(observer, baseUrl, params, headers)
    )
  },
  postService(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    baseUrl = window.$nuxt.$auth.user
      ? baseUrl.replace(
          'v1/',
          'v1/' + window.$nuxt.$auth.user.organization_id + '/'
        )
      : baseUrl
    return new Observable(
      (observer) => new http.POST(observer, baseUrl, params, headers)
    )
  },
  putService(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    baseUrl = window.$nuxt.$auth.user
      ? baseUrl.replace(
          'v1/',
          'v1/' + window.$nuxt.$auth.user.organization_id + '/'
        )
      : baseUrl
    return new Observable(
      (observer) => new http.PUT(observer, baseUrl, params, headers)
    )
  },
  deleteService(baseUrl, params, headers) {
    if (headers.Authorization) headers.Authorization = validTokenCookie()
    baseUrl = window.$nuxt.$auth.user
      ? baseUrl.replace(
          'v1/',
          'v1/' + window.$nuxt.$auth.user.organization_id + '/'
        )
      : baseUrl
    return new Observable(
      (observer) => new http.DELETE(observer, baseUrl, params, headers)
    )
  },
}
